import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";
import { PageIntro } from "../components/site/Sections";
import { DownloadDialog } from "../components/forms/DownloadDialog";

export default function Resources() {
  useSeo("Resources", "Free handouts and resources from Deaf Education Consulting LLC for families, educators and schools supporting Deaf and Hard of Hearing students.");
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/resources").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <>
      <PageIntro eyebrow="Resources" title="Handouts and resources" testid="resources-intro">
        <p>Free downloads for families, educators and school teams.</p>
      </PageIntro>
      <section className="bg-cream text-ink pb-24">
        <div className="max-w-6xl mx-auto px-6">
          {items && items.length === 0 && <p className="text-slate text-lg" data-testid="resources-empty">New resources are coming soon.</p>}
          <ul className="grid md:grid-cols-2 gap-6">
            {(items || []).map((r) => (
              <li key={r.id} className="bg-paper rounded-2xl p-6 flex gap-5" data-testid={`resource-${r.id}`}>
                <FileText className="w-8 h-8 text-teal shrink-0" aria-hidden="true" />
                <div className="min-w-0">
                  <h2 className="font-display !text-2xl">{r.title}</h2>
                  {r.description && <p className="mt-1 text-slate">{r.description}</p>}
                  <DownloadDialog resource={r} idPrefix="res" trigger={
                    <button className="mt-4 inline-flex items-center gap-2 font-sans bg-teal text-paper rounded-full px-5 py-2.5 hover:bg-teal-deep transition-colors" data-testid={`resource-download-${r.id}`}>
                      <Download className="w-4 h-4" aria-hidden="true" /> Download free <span className="sr-only">{r.title}</span> ({(r.size / 1024).toFixed(0)} KB)
                    </button>
                  } />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
